import type {AiChatProps} from '@AiChat/ai-chat.types';
import type {AiChatCallbacks, UsedImageAsset} from '@AiChat/callbacks/ai-chat-callbacks.types';
import type {SurfaceBias} from '@Components/ai-chat-window/ai-chat-window.types';

export enum AiChatEmbeddedPresentation {
  PANEL = 'panel',
  POPUP = 'popup',
}

export const AI_CHAT_POPUP_HEIGHT = 583;
export const AI_CHAT_POPUP_MIN_WIDTH = 360;

export type AiChatDismissGuard = () => boolean;
export type RegisterAiChatDismissGuard = (guard: AiChatDismissGuard | null) => void;

export interface AiChatLatestImage {
  asset: UsedImageAsset;
  previewUrl: string;
}

export type AiChatLatestImageReader = () => AiChatLatestImage | null;
export type RegisterAiChatLatestImageReader = (reader: AiChatLatestImageReader | null) => void;

export interface AiChatEmbeddedProps {
  title: string;
  callbacks?: AiChatCallbacks;
  chatId?: string;
  chatProps?: AiChatProps;
  surfaceBias?: SurfaceBias;
  presentation?: AiChatEmbeddedPresentation;
  registerDismissGuard?: RegisterAiChatDismissGuard;
  registerLatestImageReader?: RegisterAiChatLatestImageReader;
}
